import { Link } from "react-router-dom"

const NotFound = () => {
    return(
        <>
               <section class="page-404-wrap">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="image">
                            <img src="images/items/404.svg" alt=""/>
                        </div>
                        <div class="title">
                            Oops...That link is broken.
                        </div>
                        <p>Sorry for the inconvenience. Go to our homepage to check out our latest collections.</p>
                        <Link to="/" class="tf-btn btn-sm radius-3 btn-fill btn-icon animate-hover-btn">SHOP NOW</Link>
                    </div>
                </div>
            </div>
        </section>
        </>
    );
};
export default NotFound;